export default "__VITE_ASSET__25ab47ff__"